export default __webpack_public_path__ + "static/media/bot-crying-avatar.7bc72133.svg";